/**
 * @generated SignedSource<<e4922eac8895bd7a254201f1315582e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ApprovalStyle = "AUTOMATIC" | "MANUAL" | "%future added value";
export type CapabilityType = "BUILDKITE_PIPELINE" | "GITHUB_ACTIONS_WORKFLOW" | "%future added value";
export type EditCapabilityDialogQuery$variables = {
  capabilityId: any;
};
export type EditCapabilityDialogQuery$data = {
  readonly node: {
    readonly approvalStyle?: ApprovalStyle;
    readonly capabilityType?: CapabilityType;
    readonly description?: string;
    readonly id?: any;
    readonly name?: string;
    readonly parametersSchema?: any;
    readonly targetConfig?: any;
  } | null | undefined;
};
export type EditCapabilityDialogQuery = {
  response: EditCapabilityDialogQuery$data;
  variables: EditCapabilityDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "capabilityId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "capabilityId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approvalStyle",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "capabilityType",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetConfig",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parametersSchema",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditCapabilityDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "type": "GraphQLCapability",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditCapabilityDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isNode"
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "type": "GraphQLCapability",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fc4d6a30bb9bc1d6fbae9c1b3af63a4b",
    "id": null,
    "metadata": {},
    "name": "EditCapabilityDialogQuery",
    "operationKind": "query",
    "text": "query EditCapabilityDialogQuery(\n  $capabilityId: GlobalID!\n) {\n  node(id: $capabilityId) {\n    __typename\n    ... on GraphQLCapability {\n      id\n      name\n      description\n      approvalStyle\n      capabilityType\n      targetConfig\n      parametersSchema\n    }\n    __isNode: __typename\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5a3c85306432439c0560e115f6299c9a";

export default node;
